module.exports = __webpack_public_path__ + "img/ep-coeur.f8a26151.jpg";